// import external dependencies
// Polyfills
import 'custom-event-polyfill/polyfill.js';
import 'es6-object-assign/dist/object-assign-auto.js';

import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

import './global/flickity';
import './global/nav';
import './global/product-labels';
import './global/trustindex-drag';
// import './global/autocomplete';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import woocommerceCheckout from './routes/checkout';
import templateContact from './routes/googlemaps';
import product from './routes/product';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Contact page
  templateContact,
  // Checkout
  woocommerceCheckout,
  // Single product (matches body class single-product -> singleProduct via camelCase)
  singleProduct: product,
  // Also try with underscore in case Router doesn't convert
  single_product: product,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js